import { render, staticRenderFns } from "./HomeStaging.vue?vue&type=template&id=3f7fb3f4&scoped=true"
import script from "./HomeStaging.vue?vue&type=script&lang=ts"
export * from "./HomeStaging.vue?vue&type=script&lang=ts"
import style0 from "./HomeStaging.vue?vue&type=style&index=0&id=3f7fb3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7fb3f4",
  null
  
)

export default component.exports